<script>
  import { debounce, lowerCase, sortBy } from 'lodash'
  import { formatTimeForReport, WindowVariables, UserStateTransformations } from 'Utils'
  import { BASE_API_URL } from 'Utils/constants'

  const publicEventIdRegex = /[A-z0-9-_.]{1,30}-([0-9]{4}-[0-9]{1,7})/

  function agencyUsersForReports () {
    return ((window.dkVariables && window.dkVariables['agency_users_for_reports']) || []).map(user => {
      const reportUser = { ...user }

      const hasUnitNumber = reportUser.unit_number && reportUser.unit_number.trim() !== ''

      if (reportUser.first_name || reportUser.last_name) {
        reportUser.name = `${reportUser.first_name} ${reportUser.last_name}`
      } else {
        reportUser.name = `${reportUser.email}`
      }

      if (hasUnitNumber) {
        reportUser.name = `${reportUser.name} (${reportUser.unit_number})`
      }

      return reportUser
    })
  }

  function businessesForReports () {
    return (window.dkVariables && window.dkVariables['businesses_for_reports']) || []
  }

  function paySchedulesForReports () {
    return (window.dkVariables && window.dkVariables['pay_schedules_for_reports']) || []
  }

  export default {
    data () {
      return {
        csvUrl: '',
        excelUrl: '',
        agencyUsers: sortBy(agencyUsersForReports(), u => lowerCase(u.name)),
        businessNames: sortBy(businessesForReports(), b => lowerCase(b.name)),
        paySchedules: sortBy(paySchedulesForReports(), ps =>
          lowerCase(ps.name)
        ),
        fetchingData: true,
      }
    },
    computed: {
      emptyMessage () {
        return this.fetchingData ? 'Fetching Report Data...' : 'No Data Available'
      },
      payeeOptions () {
        return [
          {
            type: 'Agency',
            objects: [
              Object.assign({}, WindowVariables.agency, { type: 'Agency' }),
            ],
          },
          {
            type: 'User',
            objects: this.agencyUsers.map(u => ({
              ...u,
              type: 'User',
            })),
          },
        ]
      },
    },
    methods: {
      serializeParams (obj) {
        const str = []
        for (var p in obj) {
          if (obj.hasOwnProperty(p)) {
            let val = encodeURIComponent(obj[p])
            if (val === 'undefined' || val === 'null') {
              val = ''
            }
            str.push(`${encodeURIComponent(p)}=${val}`)
          }
        }
        return str.join('&')
      },
      currency (value) {
        return this.$options.filters.currency(value)
      },
      convertLedgerState (value) {
        return UserStateTransformations.convertLedgerState(value)
      },
      convertLedgerRefundState (value) {
        return UserStateTransformations.convertLedgerRefundState(value)
      },
      convertEventState (value) {
        return UserStateTransformations.convertEventState(value)
      },
      formatTime: formatTimeForReport,
      publicEventIdShortener (value) {
        const res = value.match(publicEventIdRegex)
        if (res) {
          return res[1]
        } else {
          return value
        }
      },
      // Target this with the button click event
      onClickCsv () {
        window.open(this.csvUrl, '_blank')
      },
      onClickExcel () {
        window.open(this.excelUrl, '_blank')
      },
      onChangePage (page) {
        this.fetchingData = true
        this.$refs.report.changePage(page)
      },
      // Override this method in the report if you need to do
      // anything extra with the `response`, just make sure to
      // also call `this.updateCsvUrl`
      onLoadSuccess () {
        this.fetchingData = false
        this.updateCsvUrl()
        this.updateExcelUrl()
      },
      onLoadSuccessWithBaseApiUrl () {
        this.fetchingData = false
        this.csvUrl = `${window.location.protocol}//${window.location.host}${
          this.apiUrl
        }.csv?${this.serializeParams(this.moreParams)}`
        this.excelUrl = `${window.location.protocol}//${window.location.host}${
          this.apiUrl
        }.xlsx?${this.serializeParams(this.moreParams)}`
      },
      onPaginationData (paginationData) {
        this.$refs.reportPagination.setPaginationData(paginationData)
      },
      refreshData () {
        // Check that the component exists in case we trigger this from `created()`
        if (this.$refs.report) {
          this.fetchingData = true
          this.$refs.report.refresh()
        }
      },
      updateCsvUrl () {
        this.csvUrl = `${window.location.protocol}//${window.location.host}${BASE_API_URL}${
          this.apiUrl
        }.csv?${this.serializeParams(this.moreParams)}`
      },
      updateExcelUrl () {
        this.excelUrl = `${window.location.protocol}//${window.location.host}${BASE_API_URL}${
          this.apiUrl
        }.xlsx?${this.serializeParams(this.moreParams)}`
      },
    },
    watch: {
      moreParams: {
        handler (val) {
          this.refreshData()
        },
        deep: true,
      },
    },
    created () {
      this.refreshData = debounce(this.refreshData, 300, { maxWait: 1000 })
    },
  }
</script>
